import React from 'react';
import { Link } from 'react-router-dom';
import { Toggle } from '../ui/Toggle';
import { useSpecSettings } from '../../contexts/SpecSettingsContext';
export function SpecNav({
  sections
}: {
  sections: {
    id: string;
    label: string;
  }[];
}) {
  const {
    reducedMotion,
    setReducedMotion,
    soundOn,
    setSoundOn
  } = useSpecSettings();
  return <header className="sticky top-0 z-40 border-b border-white/[0.06] bg-night-950/85 backdrop-blur-xl" data-id="element-1228" data-mp="3pltohn9lilkw">
      <div className="mx-auto flex h-14 max-w-[1440px] items-center gap-6 px-6 lg:px-12" data-id="element-1229" data-mp="3kol6bmog6hjn">
        <a href="#top" className="flex items-baseline gap-2 whitespace-nowrap" data-id="element-1230" data-mp="3fuz5qsvk6447">
          <span className="font-display text-[20px] font-light text-ink" data-id="element-1231" data-mp="3ayif9s0vzdny">Anna</span>
          <span className="text-[13px] text-ink-muted" data-id="element-1232" data-mp="35z5j2go4ku8p">Spec &amp; Stijl · v2</span>
        </a>
        <nav aria-label="Hoofdstukken" className="hidden flex-1 items-center gap-1 xl:flex" data-id="element-1233" data-mp="31xahdb2a8eue">
          {sections.map(s => <a key={s.id} href={`#${s.id}`} className="whitespace-nowrap rounded-full px-3 py-1.5 text-[13px] text-ink-muted transition-colors duration-150 hover:bg-white/[0.05] hover:text-ink" data-id="element-1234" data-mp="2wz0ley8qha7q">
              {s.label}
            </a>)}
        </nav>
        <div className="ml-auto flex items-center gap-5" data-id="element-1235" data-mp="46bsy0kzzzoa">
          <Link to="/" className="whitespace-nowrap rounded-full bg-white/[0.06] px-3.5 py-1.5 text-[13px] font-medium text-ink transition-colors duration-150 hover:bg-white/[0.1]" data-id="element-1236" data-mp="85av5dfchic1">
            Naar Anna-modus
          </Link>
          <Toggle label="Beperkte beweging" checked={reducedMotion} onChange={setReducedMotion} hideLabelOnMobile data-id="element-1237" data-mp="10sdozs92t4vy" />
          <Toggle label="Geluid" checked={soundOn} onChange={setSoundOn} hideLabelOnMobile data-id="element-1238" data-mp="rttc57q75pfn" />
        </div>
      </div>
    </header>;
}